import { render } from "./CloseBtn.vue?vue&type=template&id=2b7ac7d6&scoped=true"
const script = {}

import "./CloseBtn.vue?vue&type=style&index=0&id=2b7ac7d6&scoped=true&lang=css"

import exportComponent from "D:\\xampp\\htdocs\\HolyHeart\\presi\\studentapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b7ac7d6"]])

export default __exports__